import { defaultLanguage } from './consts';
import { ILanguageResourcesCollection, ILanguageServer } from './interfaces';

export class LanguageServer implements ILanguageServer {
  private readonly languages: Map<string, ILanguageResourcesCollection> = new Map();

  addLanguage(languageResources: ILanguageResourcesCollection): void {
    this.languages.set(languageResources.language, languageResources);
  }

  getLanguage(language: string): ILanguageResourcesCollection {
    return (
      this.languages.get(language) ||
      this.languages.get(defaultLanguage) ||
      (() => {
        throw new Error(`Language ${language} not found. Please register it first.`);
      })()
    );
  }

  getLanguages(): readonly string[] {
    return Array.from(this.languages.keys());
  }

  clearLanguages(): void {
    this.languages.clear();
  }
}
